import { FC } from "react";
import gsap from "gsap";
import { BaseProps } from "./text";
import GText from "./GText";
import useScrollTrigger from "../../functions/useScrollTrigger";
import { css } from "@emotion/react";

interface Props {
  text?: string;
}

const GTextGrow: FC<Props & BaseProps> = (props) => {
  const styles = css`
    position: relative;
    display: inline-block;
    padding-top: 0.2em;
    padding-right: 0.05em;
    padding-bottom: 0.1em;
    overflow: hidden;

    & .letter {
      transform-origin: 50% 100%;
      display: inline-block;
      line-height: 1em;
      transform: scale(0);
      white-space: break-spaces;
    }
  `;

  const { ref } = useScrollTrigger(() => {
    gsap.timeline().to(ref.current?.children as gsap.TweenTarget, {
      scale: 1,
      duration: 0.8,
      ease: "elastic.out(1, 0.6)",
      stagger: 0.1,
    });
  });

  const splitTextIntoSpan = () => {
    return props.text?.split("").map((l, i) => (
      <span className="letter" key={i}>
        {l}
      </span>
    ));
  };

  return (
    <GText {...props}>
      <div ref={ref} css={styles} className="g-text-grow">
        {splitTextIntoSpan()}
      </div>
    </GText>
  );
};

GTextGrow.defaultProps = {
  text: "Subscribe To Grooody",
  color: "#000",
  fontSize: 30,
};

export default GTextGrow;

// We need to add the below in framer
/*
addPropertyControls(TextGrow, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    color: {
        title: "Color",
        type: ControlType.Color,
        defaultValue: "#000",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 46,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
})

*/
